<!--
 * @Description: 金融机构管理
 * @Author: yangsibo
 * @Date: 2022-11-09 14:44:17
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-11-09 14:44:45
 * @FilePath: /adm.xiangli360.com/src/views/Bank/BankManage/index.vue
-->

<template>
    <router-view />
</template>

<script>
export default {
	name: 'BankManage',
};
</script>